import React from 'react';
import InputField from './InputField';
import TableCell from './TableCell';

const BasicInfoRow = ({
  row,
  viewMode,
  handleInputChange,
  handleOperationalRowChange,
  isOperational = false
}) => {
  const onChangeHandler = isOperational ? handleOperationalRowChange : handleInputChange;
  
  return (
    <>
      {/* Code Number */}
      <TableCell className="codeCell stickyCol1">
        <InputField
          value={row.codeNumber}
          onChange={(e) => onChangeHandler(row.id, 'codeNumber', e.target.value)}
          placeholder="कोड नं."
          readOnly={viewMode || row.is_uploaded}
          viewMode={viewMode || row.is_uploaded}
        />
      </TableCell>
      
      {/* Expense Title */}
      <TableCell className="titleCell stickyCol2">
        <InputField
          value={row.expenseTitle}
          onChange={(e) => onChangeHandler(row.id, 'expenseTitle', e.target.value)}
          placeholder="खर्च शिर्षक"
          readOnly={viewMode || row.is_uploaded}
          viewMode={viewMode || row.is_uploaded}
        />
      </TableCell>
      
      {/* Unallocated Budget */}
      <TableCell className="budgetCell stickyCol3">
        <InputField
          value={row.unallocatedBudget}
          onChange={(e, englishValue) => onChangeHandler(row.id, 'unallocatedBudget', englishValue || e.target.value)}
          placeholder=""
          readOnly={viewMode}
          viewMode={viewMode}
          isNumeric={true}
        />
      </TableCell>
      
      {/* Revised Budget */}
      <TableCell className="budgetCell stickyCol4">
        <InputField
          value={row.revisedBudget}
          onChange={(e, englishValue) => onChangeHandler(row.id, 'revisedBudget', englishValue || e.target.value)}
          placeholder=""
          readOnly={viewMode}
          viewMode={viewMode}
          isNumeric={true}
        />
      </TableCell>
    </>
  );
};

export default BasicInfoRow;
